import { Box, Typography } from '@mui/material';

export interface KpiBadgeProps {
  onColor: string;
  surfaceColor: string;
  kpi: number;
}

const formatter = Intl.NumberFormat('en', { notation: 'compact' });

export function KpiBadge({ kpi, onColor, surfaceColor }: KpiBadgeProps) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: surfaceColor,
        display: 'flex',
        borderRadius: 12,
        fontSize: '1em',
        height: 24,
        justifyContent: 'center',
        minWidth: 24,
        px: 0.75,
      }}
    >
      <Typography variant='body2' sx={{ color: onColor, fontSize: '1em', fontWeight: 600, lineHeight: 1 }}>
        {formatter.format(kpi)}
      </Typography>
    </Box>
  );
}
